// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-height: 768px) { 
        .container-error {  
        padding-top: 2vh;
        display: flex;
        flex-direction: row;
        font-size: 1.8rem;
        height: 25vh;
        margin-top: 5px;
        background: #FFF;
        border-radius: 1%;
        width: 35%;
        margin-left: auto;
        margin-right: auto;
    } 
}

.container-error.body {
    /* font-family: Segoe UI; */
    font-size: 1.8rem;
    line-height: 20px;
    color: #000;
    display: inline;
    margin: auto 5vh auto 5vh;
    background: transparent;
    width: 100%;
    text-align: center;
}

.error-title {
    text-align: center;
    color: var(--primary);
    margin-bottom: 5vh;
}

.error-icon {
    text-align: center;
}

.error-icon > .MuiSvgIcon-root {
    border: 2px solid var(--primary);
    border-radius:50%;
    font-size: 30px;
    color: var(--primary);
}`, "",{"version":3,"sources":["webpack://./src/components/Errors/AccessDenied.css"],"names":[],"mappings":"AAAA;QACQ;QACA,gBAAgB;QAChB,aAAa;QACb,mBAAmB;QACnB,iBAAiB;QACjB,YAAY;QACZ,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,UAAU;QACV,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,eAAe;IACf,qBAAqB;AACzB","sourcesContent":["@media (min-height: 768px) { \n        .container-error {  \n        padding-top: 2vh;\n        display: flex;\n        flex-direction: row;\n        font-size: 1.8rem;\n        height: 25vh;\n        margin-top: 5px;\n        background: #FFF;\n        border-radius: 1%;\n        width: 35%;\n        margin-left: auto;\n        margin-right: auto;\n    } \n}\n\n.container-error.body {\n    /* font-family: Segoe UI; */\n    font-size: 1.8rem;\n    line-height: 20px;\n    color: #000;\n    display: inline;\n    margin: auto 5vh auto 5vh;\n    background: transparent;\n    width: 100%;\n    text-align: center;\n}\n\n.error-title {\n    text-align: center;\n    color: var(--primary);\n    margin-bottom: 5vh;\n}\n\n.error-icon {\n    text-align: center;\n}\n\n.error-icon > .MuiSvgIcon-root {\n    border: 2px solid var(--primary);\n    border-radius:50%;\n    font-size: 30px;\n    color: var(--primary);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
